<!-- eslint-disable no-unused-vars -->
<template>
  <div style="width:100%;padding:0;margin:0">
    <van-field
      v-model="brand"
      readonly
      :disabled="orderSource == 1"
      label="产品品牌"
      @click-right-icon="selectType(1)"
      :right-icon="orderSource == 1 ? '' : 'arrow'"
      placeholder="请选择产品品牌，以确定最终售价"
    />
    <van-field
      v-model="spec"
      readonly
      :disabled="orderSource == 1"
      label="产品规格"
      @click-right-icon="selectType(2)"
      :right-icon="orderSource == 1 ? '' : 'arrow'"
      placeholder="请选择产品规格，以确定最终售价"
    />
    <van-field
      v-model="productItem"
      :disabled="orderSource == 1"
      label="产品编号"
      @click-right-icon="selectType(3)"
      :right-icon="orderSource == 1 || tyrePartList.length == 0 ? '' : 'arrow'"
      placeholder="请选择产品编号，以确定最终售价"
    />
    <span>{{ wording }}</span>
    <van-popup v-model:show="show" position="bottom">
      <van-picker
        :title="type == 1 ? '产品品牌' : type == 2 ? '产品规格' : type == 3 ? '产品编号' : ''"
        :columns="type == 1 ? brandList : type == 2 ? specList : type == 3 ? tyrePartList : []"
        :value-key="type == 1 || type == 2 ? 'name' : type == 3 ? 'indexString' : ''"
        :default-index="defaultIndex"
        @confirm="onConfirm"
        @cancel="onCancel"
        @change="onChange"
      >
        <template #option="item">
          <van-row style="width:100%" justify="center">
            <van-col v-if="type == 1 || type == 2" offset="9" span="10" style="text-align:left">{{ item.name }}</van-col>
            <van-col v-if="type == 3" span="19">{{ item.productNo }} {{ item.infoString }} ¥{{ item.msrp }}</van-col>
            <van-col span="5" class="fontColor">{{
              item.tagType == '1' ? '最近购买' : item.tagType == '2' ? '推荐购买' : item.tagType == '3' ? '推荐购买+最近购买' : ''
            }}</van-col>
          </van-row>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { getBrandPickerData } from '@/api/tyre'
import { Toast } from 'vant'
import _ from 'lodash'
export default {
  props: ['from'],
  emits: ['setbrandInfo'],
  setup(props, { emit }) {
    let { from } = toRefs(props)
    const store = useStore()
    let { loyaltyId, currentCarInfo, brandInfo, currentGoodsInfo } = store.state
    const state = reactive({
      defaultIndex: 1,
      from,
      inputNo: false,
      wording: null,
      orderSource: currentGoodsInfo?.orderSource,
      show: false,
      type: 1,
      isType: null,
      brand: brandInfo?.brand || '',
      spec: brandInfo?.spec || '',
      productNo: brandInfo?.productNo || '',
      brandList: brandInfo?.brandList || [{}],
      specList: brandInfo?.specList || [],
      tyrePartList: brandInfo?.tyrePartList || [],
      brandCopy: { brandList: [], specList: [], tyrePartList: [] },
      tyrePartListCopy: [],
      productItem: brandInfo?.productItem || '',
      proItem: brandInfo?.proItem || ''
    })
    onMounted(async () => {
      if (state.orderSource != 1) {
        //  if(state.from=='tireList'){
        //    await getBrandList('from')
        //     getBrandList('spec')
        //  }else{
        await getBrandList('from')
        getBrandList('1')
        //  }
        setbrandInfo()
      }
    })
    watch(
      () => state.show,
      n => {
        if (n && state.type == 3) {
          state.tyrePartList.map((i, idx) => {
            if (i.productNo == state.productNo) {
              state.defaultIndex = idx
            }
          })
        }
      }
    )
    watch(
      () => store.state.dealerInfo,
      n => {
        if (n) {
          getBrandList('1')
        }
      },
      { deep: true }
    ),
      watch(
        () => store.state.brandInfo,
        n => {
          state.brand = n.brand
          state.spec = n.spec
          state.productItem = n.productItem
          state.productNo = n.productNo
          state.brandList = n.brandList || []
          state.specList = n.specList || []
        }
      )
    watch(
      () => state.brand,
      n => {
        if (state.inputNo) {
          return
        }
        if (!n) {
          state.productNo = null
        }
        if (state.orderSource != 1) {
          getBrandList('brand')
        }
        // setbrandInfo()
      }
    )
    watch(
      () => state.spec,
      n => {
        if (state.inputNo) {
          state.inputNo = false
          return
        }
        if (!n) {
          state.productNo = null
        }
        if (state.orderSource != 1) {
          getBrandList('spec')
        }
        // setbrandInfo()
      }
    )
    watch(
      () => state.productNo,
      n => {
        if (n) {
          // setbrandInfo()
        }
      }
    )
    watch(
      () => state.productItem,
      _.debounce(n => {
        if (!state.tyrePartList.length && n) {
          state.productNo = n
          getBrandList('productNo')
        }
        if (!n) {
          state.proItem = null
          state.productNo = null
        }
        //  if(!state.tyrePartList.length && n){
        //               let val= state.tyrePartListCopy.filter(item=>n==item.productNo)
        //           if(val.length>0){
        //               if(val[0].brand && val[0].spec){
        //                    state.brand=val[0].brand
        //                    state.spec=val[0].spec
        //                    state.proItem=val[0]
        //                    state.productItem=val[0].productNo +' '+val[0].msrp+' '+val[0].infoString
        //                    state.productNo= val[0].productNo
        //               }else{
        //                 Toast('选择的产品无法匹配产品信息');
        //               }
        //           }
        //           }
      }, 1000),
      { deep: true }
    )
    const getBrandList = async type => {
      let { dealerInfo } = store.state
      const params = {
        loyaltyId,
        gsCode: dealerInfo.gsCode || dealerInfo.gs_code,
        productNo: state.brand && state.spec ? '' : state.productNo,
        baumuster: currentCarInfo.baumuster,
        fin: currentCarInfo.fin,
        spec: type == 'from' ? '' : state.spec,
        brand: type == 'from' ? '' : state.brand
      }
      state.isType = null
      // const params={loyaltyId:346,gsCode:'GS0019995',baumuster:'205042',fin:'LE42050421L362157',spec:state.spec,brand:state.brand}
      if (!params.gsCode) return
      const res = await getBrandPickerData(params)
      if (res) {
        // state.tyrePartListCopy=res.tyrePartList
        if (type == 'productNo') {
          state.inputNo = true
          state.tyrePartList = res.tyrePartList
          if (res.tyrePartList.length > 0) {
            state.brandList = res.brandList
            state.specList = res.specList
            let val = res.tyrePartList
            if (val.length == 1 && val[0].brand && val[0].spec) {
              state.brand = val[0].brand
              state.spec = val[0].spec
              state.productItem = val[0].productNo + ' ' + val[0].infoString + ' ' + val[0].msrp
              state.productNo = val[0].productNo
              state.proItem = val[0]
              setbrandInfo()
            }
          } else {
            state.tyrePartList = []
            state.productItem = null
            state.productNo = null
            state.proItem = null
            Toast('选择的产品无法匹配产品信息')
          }
          state.wording = res.wording
        } else {
          if (state.inputNo) return
          if (state.brand && state.spec) {
            state.brandList = res.brandList
            state.specList = res.specList
            state.tyrePartList = res.tyrePartList
            let val = res.tyrePartList
            if (val.length == 1) {
              state.productItem = val[0].productNo + ' ' + val[0].infoString + ' ' + val[0].msrp
              state.productNo = val[0].productNo
              state.proItem = val[0]
              setbrandInfo()
            }
          } else {
            state.tyrePartList = []
            state.productItem = null
            state.productNo = null
            state.proItem = null
          }
          if (!state.brand && !state.spec) {
            state.brandCopy = res
            state.brandList = res.brandList
            state.specList = res.specList
          }
          if (type == 1) {
            state.specList = res.specList
            state.brandList = res.brandList
          }
          if (type == 'from') {
            state.brandCopy = res
            state.specList = res.specList
            state.brandList = res.brandList
          } else {
            if (state.brand || state.spec) {
              state.brandList = state.spec ? res.brandList : state.brandCopy.brandList
              state.specList = state.brand ? res.specList : state.brandCopy.specList
            }
          }
          // if(type=='brand'){
          //   state.specList=res.specList
          // }
          // if(type=='spec' ){
          //   state.brandList=res.brandList
          // }
          state.wording = null
        }
        if (state.brandList.length == 0 || state.brandList[0].name != '空') {
          state.brandList.unshift({ name: '空' })
        }
        if (state.specList.length == 0 || state.specList[0].name != '空') {
          state.specList.unshift({ name: '空' })
        }
        setbrandInfo()
      }
    }

    const selectType = type => {
      state.type = type
      state.show = true
    }
    const setbrandInfo = () => {
      let obj = {
        brand: state.brand,
        spec: state.spec,
        productNo: state.productNo,
        productItem: state.productItem,
        proItem: state.proItem,
        brandList: state.brandList,
        specList: state.specList,
        tyrePartList: state.tyrePartList
      }
      store.commit('SETBRANDINFO', obj)
    }
    const onConfirm = (value, index) => {
      if (state.type == 1) {
        state.brand = index == 0 ? '' : value?.name
        if (value?.name == '空') {
          state.isType = 1
        }
      } else if (state.type == 2) {
        state.spec = index == 0 ? '' : value?.name
        if (value?.name == '空') {
          state.isType = 2
        }
      } else if (state.type == 3) {
        state.productItem = value?.productNo + ' ' + value?.infoString + ' ' + value?.msrp
        state.productNo = value?.productNo
        state.proItem = value
        if (!state.brand && !state.spec) {
          if (state.tyrePartList.length) {
            let val = state.tyrePartList.filter(i => i.productNo == value?.productNo)
            if (val.length > 0 && val[0].brand && val[0].spec) {
              state.brand = val[0].brand
              state.spec = val[0].spec
              state.productItem = val[0].productNo + ' ' + val[0].infoString + ' ' + val[0].msrp
              state.productNo = val[0].productNo
              state.proItem = val[0]
            }
          }
        }
      }
      let obj = {
        brand: state.brand,
        spec: state.spec,
        productNo: state.productNo,
        productItem: state.productItem,
        proItem: state.proItem,
        brandList: state.brandList,
        specList: state.specList,
        tyrePartList: state.tyrePartList
      }
      emit('setbrandInfo', obj)
      store.commit('SETBRANDINFO', obj)
      state.show = false
    }
    const onChange = () => {}
    const onCancel = () => {
      // if(state.type==1){
      //   state.isType=1
      //   state.brand=''
      // }else if(state.type==2){
      //   state.isType=2
      //   state.spec=''
      // }else if(state.type==3){
      //   state.productNo=''
      //   state.productItem=null
      //   state.proItem=null
      // }
      //  let obj={brand:state.brand,spec:state.spec,productNo:state.productNo,productItem:state.productItem,proItem:state.proItem}
      // emit('setbrandInfo',obj)
      state.show = false
    }
    return {
      ...toRefs(state),
      setbrandInfo,
      getBrandList,
      selectType,
      onChange,
      onCancel,
      onConfirm
    }
  }
}
</script>

<style lang="scss" scoped>
.wid {
  width: 100%;
  padding-left: 0;
}
.fontColor {
  color: red;
  text-align: center;
}
</style>
